export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-1200-161cb7276a44d6dcc2b0f341f1c6fbdc.webp";